import { Model } from '../base/Model';
import { formatNumber } from '../../utils/utils';
export class CardModel extends Model {
    constructor() {
        super(...arguments);
        this.isInBasket = false;
        this.isNotSaleable = false;
    }
    get categoryModifier() {
        switch (this.category.toLowerCase()) {
            case 'софт-скил':
                return 'soft';
            case 'хард-скил':
                return 'hard';
            case 'дополнительное':
                return 'additional';
            case 'кнопка':
                return 'button';
            default:
                return 'other';
        }
    }
    get formattedPrice() {
        if (this.price && typeof this.price === 'number') {
            return `${formatNumber(this.price)} синапсов`;
        }
        else {
            this.isNotSaleable = true;
            return 'Бесценно';
        }
    }
}
